import React from 'react';
import { withStyles, MenuItem, Menu, ListItemText } from '@material-ui/core';
import NavButton from 'components/NavButton';

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5'
  }
})(props => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center'
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center'
    }}
    {...props}
  />
));

const StyledMenuItem = withStyles(theme => ({
  root: {
    // '&:focus': {
    //   backgroundColor: theme.palette.primary.main,
    //   '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
    //     color: theme.palette.common.white
    //   }
    // }
  }
}))(MenuItem);

const NestedNavMenu = ({ navItem, onClickNav }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const { subNavs, text } = navItem;

  const onClickNavInternal = route => {
    setAnchorEl(null);
    onClickNav(route);
  };
  return (
    <>
      <NavButton onClick={event => setAnchorEl(event.currentTarget)}>{text}</NavButton>
      <StyledMenu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {subNavs.map(({ text, route }) => (
          <StyledMenuItem key={text} onClick={() => onClickNavInternal(route)}>
            <ListItemText primary={text} />
          </StyledMenuItem>
        ))}
      </StyledMenu>
    </>
  );
};

export default NestedNavMenu;
